import React from 'react';
import { arrayOf, node, oneOfType, string } from 'prop-types';
import classnames from 'classnames';

import styles from './EntityCard.scss';

const EntityCard = ({ className, title, children, ...props }) => (
  <div className={classnames(styles.EntityCard, className)} {...props}>
    <h3 className={styles.EntityCardTitle}>{title}</h3>
    {children}
  </div>
);

EntityCard.propTypes = {
  title: string.isRequired,
  className: string,
  children: oneOfType([node, arrayOf(node)]).isRequired,
};

export const MemoizedEntityCard = React.memo(EntityCard);
